import { useViewjobProctorAllocation } from "../../proctor/__generated__/ViewjobProctorContext";
import { RnMosaicProviderProBannerVjTog } from "../../proctor/__generated__/ViewjobProctorSpecifications";

export type CtaButtonTextType = {
  default: string;
  freeTrial: string;
};

export type MosaicProviderProBannerVjTogPayloadWithObjectCta = {
  ctaButtonText: CtaButtonTextType;
  ctaContentText: string;
};

export type MosaicProviderProBannerVjTogPayloadWithStringCta = {
  ctaButtonText: string;
  ctaContentText: string;
};

export type MosaicProviderProBannerVjTogPayloadType =
  | MosaicProviderProBannerVjTogPayloadWithObjectCta
  | MosaicProviderProBannerVjTogPayloadWithStringCta;

export function useMosaicProviderProBannerVjTogPayload(): MosaicProviderProBannerVjTogPayloadType | null {
  const proctorAllocation = useViewjobProctorAllocation(RnMosaicProviderProBannerVjTog);
  const payloadJson = proctorAllocation.payloadJson;

  if (!payloadJson) {
    return null;
  }

  try {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
    return JSON.parse(payloadJson) as MosaicProviderProBannerVjTogPayloadType;
  } catch {
    return null;
  }
}

export function useHasCtaAccess(): boolean {
  const proctorAllocation = useViewjobProctorAllocation(RnMosaicProviderProBannerVjTog);
  return proctorAllocation.value >= 2;
}

export function useMosaicProviderProBannerVjTogVariant(): number {
  const proctorAllocation = useViewjobProctorAllocation(RnMosaicProviderProBannerVjTog);
  return proctorAllocation.value;
}
